export default "__VITE_ASSET__BRm64Wh2__"